import Axios from "axios";
import { getOAuthHeaders } from "../constants/oAuthValidation";

const updateOfdStatus = async ({
  sOrderID,
  newStatus,
  isAuto = false,
  reasonCode = null,
  printFlag = "Y",
  serverUrl = process.env.REACT_APP_serverUrl,
}) => {
  const authHeaders = getOAuthHeaders();
  const setAuthTokens = authHeaders.access_token;

  const statusMapping = {
    Acknowledged: "AK",
    Cancelled: "CC",
    "Food Ready": "FR",
    Dispatched: "DI",
  };
  const statusCode = statusMapping[newStatus] || newStatus;

  try {
    const response = await Axios({
      url: serverUrl,
      method: "POST",
      data: {
        query: `mutation {
          upsertOfdOrderStatus(order: [{
            sOrderID: "${sOrderID}"
            ofdStatus: "${statusCode}"
            print: "${printFlag}"
          }]) { 
            status
            message   
          }
        }`,
      },
      headers: {
        "Content-Type": "Application/json",
        Authorization: `${setAuthTokens}`,
      },
    });

    const result = response?.data?.data?.upsertOfdOrderStatus;
    if (result?.status === "200") {
      return {
        success: true,
        message: result.message,
        statusCode,
      };
    } else {
      console.error("Status update failed:", result?.message);
      return {
        success: false,
        message: result?.message || "Failed to update order status",
      };
    }
  } catch (error) {
    console.error("Error updating order status:", error);
    return {
      success: false,
      message: "Error updating order status",
    };
  }
};

export default updateOfdStatus;